"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.moon = void 0;
var moon = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.72 0c-1.58.53-2.72 2.02-2.72 3.78 0 2.21 1.79 4 4 4 1.76 0 3.25-1.14 3.78-2.72-.4.13-.83.22-1.28.22-2.21 0-4-1.79-4-4 0-.45.08-.88.22-1.28z"
    }
  }]
};
exports.moon = moon;